// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"073f3a79","2148":"60334499","7581":"97198932","7929":"5919aaeb","8031":"4c6b9566","8851":"60334499","9199":"073f3a79","9623":"60334499"}[chunkId] + ".chunk.css";
};